// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'נסה שוב להשתמש בתאריך מלא כזה: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'קבוצה',
  chart_labelSeries: () => 'סדרה',
  chart_labelValue: () => 'ערך',
  checkboxSet_requiredMessageDetail: () => 'דרוש',
  checkbox_requiredMessageDetail: () => 'דרוש',
  close: () => 'סגור',
  collection_noData: () => 'אין נתונים להצגה.',
  collection_selectAllRows: () => 'בחר את כל השורות',
  collection_selectRow: (p: { ROW_NAME: string }) => 'בחר את שורה ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'לא ניתן למיון',
  collection_sortEnabled: () => 'ניתן למיון',
  confirmation: () => 'אישור',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' מתוך ' + p['totalCount'],
  dataVisualization_noData: () => 'אין נתונים להצגה',
  dataVisualization_stateSelected: () => 'נבחר',
  dataVisualization_stateUnselected: () => 'לא נבחר',
  error: () => 'שגיאה',
  expandableList_expandCollapseInstructionText: () => 'יש להשתמש במקשי החצים כדי להרחיב ולצמצם',
  expandableList_groupCollapse: () => 'מכווץ',
  expandableList_groupExpand: () => 'מורחב',
  filePicker_addFiles: () => 'הוסף קבצים',
  filePicker_dropzonePrimaryText: () => 'גרור ושחרר',
  filePicker_dropzoneSecondaryText: () => 'בחר קובץ או שחרר אותו כאן',
  filePicker_dropzoneSecondaryTextMultiple: () => 'בחר קבצים או שחרר אותם כאן',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'אי אפשר להעלות קבצים מסוג: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'טען קובץ אחד בכל פעם',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'אי אפשר להעלות קבצים מסוג ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'לא ידוע',
  formControl_clear: () => 'מחק',
  formControl_day: () => 'יום',
  formControl_helpAvailable: () => 'עזרה זמינה',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'הגעת למגבלה של ' +
    (({ one: 'תו אחד', two: 'שני תווים' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('he').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('he').format(p['CHARACTER_LIMIT']) + ' תווים') +
    '.',
  formControl_loading: () => 'טוען',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'חריגה מהאורך המרבי ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' תווים נותרו.',
  formControl_month: () => 'חודש',
  formControl_readOnly: () => 'קריאה בלבד',
  formControl_requiredMessageDetail: () => 'הזן ערך.',
  formControl_year: () => 'שנה',
  gantt_labelDate: () => 'תאריך',
  gantt_labelEnd: () => 'סיום',
  gantt_labelLabel: () => 'תווית',
  gantt_labelRow: () => 'שורה',
  gantt_labelStart: () => 'התחלה',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. לא נמצא פרק תואם.',
  indexer_keyboardInstructionText: () => 'לחץ על Enter כדי לבחור ערך.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'בין ' + p['FROM_SECTION'] + ' ו-' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'הקש פעמיים והחזק כדי להיכנס למצב מחוות, ולאחר מכן גרור מעלה ומטה כדי להתאים את הערך.',
  info: () => 'מידע',
  inputDateMask_date_cleared: () => 'תאריך נמחק',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'ריק',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputNumber_converterParseError: () => 'הזן מספר.',
  inputNumber_decrease: () => 'הקטן',
  inputNumber_increase: () => 'הגדל',
  inputPassword_hidden: () => 'סיסמה נסתרת',
  inputPassword_hide: () => 'הסתר סיסמה',
  inputPassword_show: () => 'הצג סיסמה',
  list_suggestion: () => 'הצעה',
  messageToast_allMessagesClosed: () => 'כל ההודעות המוקפצות סגורות.',
  message_close: () => 'סגור',
  message_confirmation: () => 'הצלחה',
  message_error: () => 'שגיאה',
  message_info: () => 'מידע',
  message_navigationFromMessagesRegion: () =>
    'מזין אזור הודעות. לחץ על F6 כדי לנווט חזרה לרכיב שהיה קודם במוקד.',
  message_navigationToMessagesRegion: () =>
    'אזור ההודעות מכיל הודעות חדשות. לחץ על F6 כדי לנווט לאזור ההודעות האחרון.',
  message_warning: () => 'אזהרה',
  noData_message: () => 'אין פריטים להצגה',
  overflowItemLabel: () => 'כרטיסיות נוספות',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'בתהליך',
  radio_helpForRadio: () => 'עזרה לכפתור רדיו',
  radio_requiredMessageDetail: () => 'בחר ערך',
  selectMultiple_apply: () => 'החל',
  selectMultiple_back: () => 'חזרה',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'הקש על Backspace או Delete כדי להסיר את הערך שנבחר.',
  selectMultiple_selectedValues: () => 'ערכים נבחרים',
  selectMultiple_showSelectedValues: () => 'הצג ערכים בלבד.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) => p['VALUE_COUNT'] + ' ערכים נבחרו.',
  select_addToList: () => 'הוספה לרשימה',
  select_addToListAvailable: () => 'הוספה לרשימה זמינה',
  select_moreSearchOptions: () => 'אפשרויות חיפוש נוספות',
  select_moreSearchOptionsAvailable: () => 'אפשרויות חיפוש נוספות זמינות',
  select_noMatchesFound: () => 'לא נמצאו התאמות.',
  select_oneMatchFound: () => 'נמצאה התאמה אחת',
  select_requiredMessageDetail: () => 'בחר ערך',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' התאמות נמצאו',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' או יותר התאמות נמצאו',
  selector_selected: () => 'תיבת תיוג מסומנת',
  selector_unselected: () => 'תיבת תיוג לא מסומנת',
  tabBarNavigationList_removeCueText: () => 'ניתן להסרה',
  timeComponent_tooltipZoomIn: () => 'התקרבות',
  timeComponent_tooltipZoomOut: () => 'התרחקות',
  train_current: () => 'שוטף',
  train_message_type: () => 'סוג הודעה',
  train_not_visited: () => 'לא נרשמו ביקורים',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'שלב ' + p['currentStep'] + ' מתוך ' + p['numberOfSteps'],
  train_visited: () => 'נרשמו ביקורים',
  userAssistance_learnMore: () => 'פרטים נוספים',
  userAssistance_required: () => 'דרוש',
  viz_drillable: () => 'ניתן לגלילה',
  warn: () => 'אזהרה'
};
export default bundle;
